import { compose } from 'recompose'

import { withSearchContext } from 'components/Tree'
import { withFilterContext } from 'components/SectionHandler'
import { withSavedPathContext } from 'components/SectionHandler'
import { withRefreshSideList } from 'components/SectionHandler'
import { withStatusIndicatorContext } from 'components/graphql'

const withAppContext = App => compose(
	withSearchContext,
	withFilterContext,
	withSavedPathContext,
	withRefreshSideList,
	withStatusIndicatorContext
)(App)


export default withAppContext
